
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.243 17.243l-.53-.531.53.53zM2.757 8.757l.53.53.008-.006-.538-.524zm6.415-6.585l-.53-.53-.008.006.538.524zm5.656 0l-.53.53.53-.53zm0 5.656l-.53-.53-.007.007.537.523zm-9.242 3.758l-.53-.53.53.53zm2.828 2.828l.53.53.007-.007-.537-.523zm4.288-8.884a.75.75 0 10-1.06-1.06l1.06 1.06zm5.328 6.001a.75.75 0 00-1.06-1.062l1.06 1.062zm-7.318 5.181a5.25 5.25 0 01-7.424 0l-1.061 1.061a6.75 6.75 0 009.546 0l-1.06-1.06zm-7.424 0a5.25 5.25 0 010-7.424L2.227 8.227a6.75 6.75 0 000 9.546l1.06-1.06zm6.414-14.01a3.25 3.25 0 014.596 0l1.06-1.06a4.75 4.75 0 00-6.717 0l1.06 1.06zm4.596 0a3.25 3.25 0 010 4.596l1.06 1.06a4.75 4.75 0 000-6.717l-1.06 1.06zm-9.243 8.354a2.75 2.75 0 000 3.889l1.061-1.061a1.25 1.25 0 010-1.768l-1.06-1.06zm0 3.889a2.75 2.75 0 003.89 0l-1.061-1.061a1.25 1.25 0 01-1.768 0l-1.06 1.06zm9.236-7.64l-6.414 6.586 1.074 1.046 6.415-6.585-1.075-1.047zM3.295 9.281l6.414-6.586-1.075-1.047L2.22 8.234l1.075 1.047zm2.821 2.835l6.586-6.586-1.06-1.06-6.587 6.586 1.061 1.06zm5.656 5.658l6.258-6.243-1.06-1.062-6.257 6.243 1.06 1.062z"}})])
          )
        }
      }
    